<template>
  <div>
    <v-server-table
      id="iframeTonalBlockTable"
      ref="iframeTonalBlockTable"
      name="iframeTonalBlockTable"
      :columns="columns"
      :options="tableOptions"
      @limite="this.selectedBlocks = {}"
      @filter="onFilterUpdate"
      @loading="isLoading=true"
      @loaded="onLoaded"
      @row-click="handleBlockClicked"
      @pagination="onPagination"
    >
      <span slot="afterFilter">
        <div class="row">
          <Filters
            :isActive="showFilters"
            :activeFilters="activeFilters"
            @toggle-filters="toggleFilters"/>
          <Searchable class="mr-2" :querySearch.sync="filters.querySearch" style="line-height: 1 !important; margin-top: 0 !important;"/>
        </div>

      </span>
      <span slot="afterFilterWrapper">
        <div class="row mt-2 no-gutters evollu-form" v-if="showFilters">
          <div class="row">
            <RangeDatePicker
              id="created-date-picker"
              v-model="filters.date"
              class="col-12 col-md-4 datesFilter"
              :placeholder="$t('iframe.table_headings.created_at')">

          <div slot="label">
            <label class="form-label" style="margin-top: -3px;">
              {{ $t('iframe.table_headings.created_at') }}
            </label>
          </div>
        </RangeDatePicker>
          </div>
        </div>
      </span>
      <span slot="beforeFilter">
        <!--<span>
          <va-popover
            v-if="selectedBlockIds.length > 0"
            placement="left"
            :message="$t('iframe.actions.clone')">
            <span class="icon fa fa-copy clickable" @click.prevent="onClickClone()"></span>
          </va-popover>
      </span>-->
        <span>
          <va-popover
            v-if="selectedBlockIds.length > 0"
            placement="left"
            :message="$t('iframe.actions.delete')">
            <span class="icon fa fa-trash-o clickable" @click.prevent="onClickDelete()"></span>
          </va-popover>
        </span>
        <!--<span>
          <va-popover
            v-if="selectedBlockIds.length > 0"
            placement="left"
            :message="$t('iframe.actions.lock')">
            <span class="icon fa fa-lock clickable" @click.prevent="onClickLock()"></span>
          </va-popover>
        </span>-->
      </span>

      <span slot="h__selectBlock">
        <span class="round">
          <input class="selectBlockCheckbox" type="checkbox" id="checkboxSelectAllBlocks" :checked="selectAllBlocks" @click="selectAllBlocks = !selectAllBlocks">
          <label class="selectBlockCheckbox" for="checkboxSelectAllBlocks"></label>
        </span>
      </span>

      <span slot="actions" slot-scope="props" class="w-100 d-flex justify-content-center">
        <!--<va-popover :message="$t('iframe.actions.clone')" placement="top">
          <i class="report-action-icon fa fa-copy p-2 clickable"
             @click.prevent.stop="onClickClone(props.row)"></i>
        </va-popover>-->
        <va-popover :message="$t('iframe.actions.delete')" placement="top">
          <i class="report-action-icon fa fa-trash-o p-2 clickable" @click.prevent.stop="onClickDelete(props.row)"></i>
        </va-popover>
       <!--<va-popover :message="$t('iframe.actions.lock')" placement="top">
          <i class="report-action-icon fa fa-lock p-2 clickable" @click.prevent.stop="onClickLock(props.row)"></i>
        </va-popover>-->
      </span>

      <span slot="created_at" slot-scope="props">
        {{props.row.created_at | localTime('YYYY-MM-DD HH:mm')}}
      </span>
      <span slot="updated_at" slot-scope="props">
        {{props.row.updated_at | localTime('YYYY-MM-DD HH:mm')}}
      </span>
      <span slot="lang" slot-scope="props">
        {{props.row.lang.toUpperCase() || "N/A"}}
      </span>
      <span slot="client" slot-scope="props">
          {{props.row.client_id ? clientOptions.find(elem => elem.id === props.row.client_id).name : "N/A"}}
        </span>

      <span slot="selectBlock" slot-scope="props" >
        <span class="round">
          <input class="selectBlockCheckbox" type="checkbox" :id="`checkbox${props.row.id}`" :checked="selectedBlocks[props.row.id]" @click="handleBlockSelected(props.row)">
          <label class="selectBlockCheckbox" :for="`checkbox${props.row.id}`"></label>
        </span>
      </span>
    </v-server-table>

    <FadeTransition
      :duration="400"
      mode="out-in">
      <div class="btn btn__floating btn__round__large btn__round__large"
           v-if="writeEntities.length > 0">
        <va-popover
          :message="$t('iframe.titles.create_new_block')"
          placement="left"
        >
          <va-button
            @click.prevent="onClickCreateBlock">
            <i class="fa fa-plus"></i>
          </va-button>

        </va-popover>

      </div>
    </FadeTransition>
    <CreateTonalBlock
      v-if="showCreateBlock"
      @cancel="onCreateBlockCancel"
      @created="onCreated"
    />

    <ConfirmationModal
      v-if="showDeleteConfirmationModal"
      :title="selectedBlockToDelete !== null ? $t('iframe.blocks_builder.delete_block_title') : $t('iframe.blocks_builder.delete_multiple_blocks_title')"
      :body="selectedBlockToDelete !== null ? $t('iframe.blocks_builder.delete_block_body', {name: selectedBlockToDelete.name}): $t('iframe.blocks_builder.delete_multiple_blocks_body', {nr: getSelectedBlocksIds().length})"
      @modal-confirmed="deleteBlock"
      @modal-canceled="onDeleteConfirmCancel"
    />

    <ConfirmationModal v-if="showCloningConfirmationModal"
                       :title="cloningConfirmationModalTitle"
                       :body="cloningConfirmationModalBody"
                       okClass="btn-danger"
                       @modal-confirmed="showCloneModeSelectionModal"
                       @modal-canceled="cancelClone"
    >
    </ConfirmationModal>
    <CloneModeSelectionModal v-if="showCloningModeSelectionModal"
                             @confirm="confirmClone"
                             @cancel="cancelClone">

    </CloneModeSelectionModal>
    <ConfirmationModal v-if="showLockConfirmationModal"
                       :title="lockConfirmationModalTitle"
                       :body="lockConfirmationModalBody"
                       okClass="btn-danger"
                       @modal-confirmed="confirmLock"
                       @modal-canceled="cancelLock"/>
  </div>
</template>

<script>
import TableQueryMixin from "@/mixins/TableQueryMixin";
import Searchable from "@/components/common/Searchable";
import {TABLE_IFRAME_BLOCK_TONAL} from "@/local-storage/LocalStorageKeys";
import FadeTransition from "@/components/common/transitions/FadeTransition";
import CreateTonalBlock from "@/components/iframe/blocks-builder/tonal/CreateTonalBlock";
import ConfirmationModal from "@/components/common/ConfirmationModal";
import IframeBlocksTableMixin from "@/mixins/IframeBlocksTableMixin";
import Filters from '@/components/common/Filters'
import RangeDatePicker from "@/components/common/RangeDatePicker";
import IndexTablesMixin from "@/mixins/IndexTablesMixin";
import CloneModeSelectionModal from "@/components/iframe/CloneModeSelectionModal";



export default {
  components: {
    CloneModeSelectionModal,
    RangeDatePicker, Filters, ConfirmationModal, CreateTonalBlock, FadeTransition, Searchable},
  props: {
    writeEntities: {
      type: Array,
      required: false,
      default: []
    }
  },
  mixins: [
    TableQueryMixin,
    IframeBlocksTableMixin,
    IndexTablesMixin
  ],
  data: function() {
    return {
      showFilters: false,
      activeFilters: 0,
      customQueries: null,
      showDeleteConfirmationModal: false,
      selectedBlockToDelete: null,
      localStorageKey: TABLE_IFRAME_BLOCK_TONAL,
      blockTypeIdentifier: 'tonal',
      pageResourceIdentifier: 'tonal-pages',
      filters: {
        querySearch: '',
        date: {
          start: this.moment().subtract(1, 'months').format('YYYY-MM-DD'),
          end: this.moment().format('YYYY-MM-DD'),
        },
      },
      isLoading: false,
      queryUrl: `${this.$store.state.iframe_server}v1/tonal-pages`,
      columns: ['selectBlock','created_at', 'name', 'client', 'lang', 'actions'],
      tableOptions: {
        orderBy: {
          column: 'created_at',
          ascending: false
        },
        saveState: true,
        storage: 'local',
        filterable: ['created_at'],
        sortable: ['created_at'],
        customFilters: ['start', 'end'],
        columnsClasses: {
          selectBlock: 'selectBlockClass',
          created_at: 'createdAtClass',
          lang: 'text-center',
          actions: 'w-100 d-flex justify-content-center'
        },
        headings: {
          created_at: this.$t('iframe.table_headings.created_at'),
          name: this.$t('iframe.table_headings.name'),
          lang: this.$t('iframe.table_headings.lang'),
          actions: this.$t('iframe.table_headings.actions'),
          client: this.$t('iframe.table_headings.client')
        }
      },
      selectedBlock: null,
      showCreateBlock: false,
      selectedBlocks: {},
      selectedBlockIds: [],
      selectAllBlocks: false,
      showCloningConfirmationModal: false,
      showCloningModeSelectionModal: false,
      selectedBlockForCloning: null,
      selectedCloningMode: null,
      selectedFlowForCloning: null,
      showLockConfirmationModal: false,
      selectedBlockForLock: null
    }
  },
  mounted() {
    let dropdownList = this.$el.getElementsByClassName('VueTables__columns-dropdown')[0].lastElementChild
    dropdownList.removeChild(dropdownList.childNodes[0])
  },
  methods: {
    getData: function() {
      return this.$refs.iframeTonalBlockTable.data
    },
    refreshTable: function() {
      this.$refs.iframeTonalBlockTable.refresh()
    },
    toggleFilters: function () {
      this.showFilters = !this.showFilters
    },
  },
  watch: {
    customQueries: {
      handler: function (value) {
        if (value) {
          if (value.start && value.start !== '') {
            this.filters.date.start = value.start
          }
          if (value.end && value.end !== '') {
            this.filters.date.end = value.end
          }
        }
      },
      immediate: true
    },
    'filters.querySearch': function (value) {
      this.$refs.iframeTonalBlockTable.setFilter(value)
    },
    'filters.date': function (value) {
      this.$refs.iframeTonalBlockTable.customQueries.start = value.start || ''
      this.emitTableFilter('vue-tables.iframeTonalBlockTable.filter::end', value.end || '')
    },
  },
  computed: {
    iframeService: function () {
      return this.$store.state.services.find(service => service.slug === 'iframe') || null
    },
    clientOptions: function () {
      if (this.iframeService) {
        if (this.iframeService.user_permissions.some(perm => perm.entity_id === null)) {
          return this.iframeService.entities
        }
        const consideredEntitiesIds = this.iframeService.user_permissions.filter(perm => perm.access_type >= 1 && perm.info_type === 120).map(elem => elem.entity_id)
        return this.iframeService.entities.filter(entity => consideredEntitiesIds.includes(entity.id))
      }
      return []
    },
  }
}
</script>

<style>
.selectBlockClass{
  width: 50px;
}
.createdAtClass {
  max-width: 300px;
}
#iframeTonalBlockTable .VueTables__search {
  justify-content: space-between;
  float:none !important;
}
.table-hover tbody tr:hover {
  background: rgba(41, 196, 170, 0.5) !important;
}
</style>
<style scoped>
.round {
  position: relative;
}

.round label {
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 50%;
  cursor: pointer;
  height: 1.375rem;
  left: 0;
  position: absolute;
  top: 0;
  width: 1.375rem;
}

.round label:after {
  border: 2px solid #fff;
  border-top: none;
  border-right: none;
  content: "";
  height: 6px;
  left: 5px;
  opacity: 0;
  position: absolute;
  top: 6px;
  transform: rotate(-45deg);
  width: 12px;
}

.round input[type="checkbox"] {
  visibility: hidden;
}

.round input[type="checkbox"]:checked + label {
  background-color: #29c4a9;
  border-color: #29c4a9;
}

.round input[type="checkbox"]:checked + label:after {
  opacity: 1;
}
</style>
